var exports = {
  "n": "xa15a2ab7--03394b--link",
  "x": "xa15a2ab7--03394b--button",
};

module.exports = exports;
